/** RFC 7807 problem from the API, plus transport failures. `code` is stable and drives translated messages. */
export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: string,
    message: string,
    public readonly details?: unknown,
    public readonly requestId?: string,
  ) {
    super(message);
    this.name = 'ApiError';
  }

  get isNetwork(): boolean {
    return this.status === 0;
  }
}

interface ProblemBody {
  code?: string;
  title?: string;
  details?: unknown;
  request_id?: string;
}

export function problemFrom(status: number, body: unknown): ApiError {
  const p = (body && typeof body === 'object' ? body : {}) as ProblemBody;
  return new ApiError(status, p.code ?? 'unknown', p.title ?? `HTTP ${status}`, p.details, p.request_id);
}

/** Returns data or throws ApiError. Works with openapi-fetch result objects. */
export function unwrap<T>(r: { data?: T; error?: unknown; response: Response }): T {
  if (r.error !== undefined || !r.response.ok) throw problemFrom(r.response.status, r.error);
  return r.data as T;
}
